import { IPatient } from '../../constants/types';

/**
 * SHER-233: the agenda pages used to inline
 * `state.investigations.currentInvestigation && state.patients.data
 *     ? state.patients.data[currentInvestigation.uuid]
 *     : []`
 * in their `mapStateToProps`. That `[]` is a brand-new array literal on every
 * invocation, so while it was the taken branch `connect()`'s shallow-equality
 * check saw a changed `personalData` prop on *every* store notification and
 * re-rendered the whole agenda tree — including on dispatches carrying
 * nothing relevant to it.
 *
 * Sharing one frozen empty array keeps that branch referentially stable, so
 * `connect()` can bail out. The populated branch is passed through by
 * reference, exactly as before — this changes identity behaviour only, never
 * values.
 */
const EMPTY_PERSONAL_DATA: IPatient[] = [];

export function selectPersonalData(state: any): IPatient[] {
    const currentInvestigation = state.investigations.currentInvestigation;
    if (!currentInvestigation || !state.patients.data) {
        return EMPTY_PERSONAL_DATA;
    }
    // `patients.data` accumulates one key per investigation as each loads, so a
    // populated object that lacks this investigation's key is a real state
    // (switching investigation/organisation) — and these pages gate rendering
    // on `hospital.loading` / `investigations.loading`, never `patients.loading`.
    // Falling back keeps the `IPatient[]` promise honest: every consumer calls
    // `.filter`/`.find` on this unguarded, so `undefined` would crash them.
    return state.patients.data[currentInvestigation.uuid] ?? EMPTY_PERSONAL_DATA;
}
